namespace SolovisGateway.Admin.DataEnvironments {

    export class EditDataEnvironmentEditorControl extends Solovis.UI.BaseControl {
        private _dataEnvironmentId;
        private _isDirty;

        private _dataEnvironmentInfo;
        private _environmentPools;
        private _organizations;

        public _formBuilder: Solovis.UI.InputControls.FormBuilder;

        public _savedDataEnvironmentEditorModel;

        constructor(options) {
            super(options);

            if (!options.dataEnvironmentId) {
                throw "SolovisGateway.Admin.DataEnvironments.EditDataEnvironmentEditorControl: Missing parameter dataEnvironmentId";
            }

            this._dataEnvironmentId = options.dataEnvironmentId;

            this._isDirty = false;
        }


        public async doInitAsync(): Promise<void> {
            var self = this;

            let response = await Solovis.Rpc.invoke(
                "~/Admin/DataEnvironmentAdmin/GetEditDataEnvironmentDialogInitialState",
                { id: this._dataEnvironmentId });
                                    
            this._dataEnvironmentInfo = response.result.dataEnvironmentInfo ? response.result.dataEnvironmentInfo : null;
            this._environmentPools = response.result.environmentPools ? response.result.environmentPools : [];
            this._organizations = response.result.organizations ? response.result.organizations : [];
        }
        

        public doRender() {
            var self = this;

            this.container
                .addClass("value-editor");           

            var formDiv = $("<div>").appendTo(this.container);
            var formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formDiv
            });

            // Subdomain
            formBuilder.addEntry({
                name: "subdomain",
                label: "Subdomain",

                initialValue: this._dataEnvironmentInfo.subdomain ? this._dataEnvironmentInfo.subdomain : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "text",
                        required: true,
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                    });

                    return editorControl;
                }
            });

            // Description
            formBuilder.addEntry({
                name: "description",
                label: "Description",

                initialValue: this._dataEnvironmentInfo.description ? this._dataEnvironmentInfo.description : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "text",
                        required: true,
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                }
            });

            // Site Virtual Path
            formBuilder.addEntry({
                name: "siteVirtualPath",
                label: "Site Virtual Path",

                initialValue: this._dataEnvironmentInfo.siteVirtualPath ? this._dataEnvironmentInfo.siteVirtualPath : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "text",
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                }
            });

            // Test Environment
            formBuilder.addEntry({
                name: "isTestEnvironment",
                label: "Test Environment",

                initialValue: Solovis.isNotNull(this._dataEnvironmentInfo.isTestEnvironment) ? this._dataEnvironmentInfo.isTestEnvironment : false,

                editor: {
                    type: "bool"
                }
            });

            // InvDataConnectionString
            formBuilder.addEntry({
                name: "invDataConnectionString",
                label: "InvData Connection String",

                initialValue: this._dataEnvironmentInfo.invDataConnectionString ? this._dataEnvironmentInfo.invDataConnectionString : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControls.TextAreaInputControl({
                        container: createEditorOptions.container,
                        required: true,
                        width: 400,
                        rows: 3,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        cssRules: {
                            "resize": "both"
                        }
                    });

                    return editorControl;
                }
            });

            // InvDataAdminConnectionString
            formBuilder.addEntry({
                name: "invDataAdminConnectionString",
                label: "InvData Admin Connection String",

                initialValue: this._dataEnvironmentInfo.invDataAdminConnectionString ?
                    this._dataEnvironmentInfo.invDataAdminConnectionString :
                    null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControls.TextAreaInputControl({
                        container: createEditorOptions.container,
                        required: true,
                        width: 400,
                        rows: 3,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        cssRules: {
                            "resize": "both"
                        }
                    });

                    return editorControl;
                }
            });

            // InvDataBackupAzureStorageConnectionString
            formBuilder.addEntry({
                name: "invDataBackupAzureStorageConnectionString",
                label: "InvData Backup Azure Storage Connection String",

                initialValue: this._dataEnvironmentInfo.invDataBackupAzureStorageConnectionString ?
                    this._dataEnvironmentInfo.invDataBackupAzureStorageConnectionString :
                    null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControls.TextAreaInputControl({
                        container: createEditorOptions.container,
                        width: 400,
                        rows: 3,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        cssRules: {
                            "resize": "both"
                        }
                    });

                    return editorControl;
                }
            });

            // InvDataBackupAzureStorageContainer
            formBuilder.addEntry({
                name: "invDataBackupAzureStorageContainer",
                label: "InvData Backup Azure Storage Container",

                initialValue: this._dataEnvironmentInfo.invDataBackupAzureStorageContainer ?
                    this._dataEnvironmentInfo.invDataBackupAzureStorageContainer :
                    null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "text",
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                }
            });

            // CustomDataAzureStorageConnectionString
            formBuilder.addEntry({
                name: "customDataAzureStorageConnectionString",
                label: "Custom Data Azure Storage Connection String",

                initialValue: this._dataEnvironmentInfo.customDataAzureStorageConnectionString ?
                    this._dataEnvironmentInfo.customDataAzureStorageConnectionString :
                    null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControls.TextAreaInputControl({
                        container: createEditorOptions.container,
                        width: 400,
                        rows: 3,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel,
                        cssRules: {
                            "resize": "both"
                        }
                    });

                    return editorControl;
                }
            });

            // CustomDataAzureStorageContainer
            formBuilder.addEntry({
                name: "customDataAzureStorageContainer",
                label: "Custom Data Azure Storage Container",

                initialValue: this._dataEnvironmentInfo.customDataAzureStorageContainer ?
                    this._dataEnvironmentInfo.customDataAzureStorageContainer :
                    null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "text",
                        max: 255,
                        width: 300,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                }
            });

            // Port
            formBuilder.addEntry({
                name: "port",
                label: "Port",

                initialValue: this._dataEnvironmentInfo.port ? this._dataEnvironmentInfo.port : null,

                createEditor: function (createEditorOptions) {
                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "number",
                        width: 300,
                        decimals: 0,
                        value: createEditorOptions.initialValue,
                        validationModel: createEditorOptions.validationModel
                    });

                    return editorControl;
                }
            });

            // Organization
            formBuilder.addEntry({
                name: "organization",
                label: "Organization (optional)",

                initialValue: this._dataEnvironmentInfo.organization ? this._dataEnvironmentInfo.organization.id : null,

                createEditor: function (createEditorOptions) {
                    var organizationOptions = [{ text: "", value: null }];

                    if (self._organizations.length) {
                        $(self._organizations).each(function (i, org: any) {
                            organizationOptions.push({
                                text: org.name,
                                value: org.id
                            });
                        });
                    }


                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "select",
                        data: organizationOptions,
                        value: createEditorOptions.initialValue
                    });

                    return editorControl;
                },

                postSetup: function (formEntry) {
                    formEntry.showEntry(self._organizations.length > 0);
                }
            });

            // Environment Pool
            formBuilder.addEntry({
                name: "environmentPool",
                label: "Environment Pool",

                initialValue: this._dataEnvironmentInfo.environmentPool ? this._dataEnvironmentInfo.environmentPool.id : null,

                createEditor: function (createEditorOptions) {
                    var environmentPoolOptions = [{ text: "", value: null }];

                    if (self._environmentPools.length) {
                        $(self._environmentPools).each(function (i, envPool: any) {
                            environmentPoolOptions.push({
                                text: envPool.name,
                                value: envPool.id
                            });
                        });
                    }


                    var editorControl = new Solovis.UI.InputControl({
                        container: createEditorOptions.container,
                        type: "select",
                        data: environmentPoolOptions,
                        value: createEditorOptions.initialValue
                    });

                    return editorControl;
                },

                postSetup: function (formEntry) {
                    formEntry.showEntry(self._environmentPools.length > 0);
                }
            });

            formBuilder.setupDone();

            $(formBuilder).bind("valueChanged", function () {
                self._isDirty = true;
            });

            this._formBuilder = formBuilder;
        };

        public _getEditDataEnvironmentModel() {
            var subdomain = this._formBuilder.getValueByName("subdomain");
            var description = this._formBuilder.getValueByName("description");
            var siteVirtualPath = this._formBuilder.getValueByName("siteVirtualPath");
            var isTestEnvironment = this._formBuilder.getValueByName("isTestEnvironment");
            var invDataConnectionString = this._formBuilder.getValueByName("invDataConnectionString");
            var invDataAdminConnectionString = this._formBuilder.getValueByName("invDataAdminConnectionString");
            var invDataBackupAzureStorageConnectionString = this._formBuilder.getValueByName("invDataBackupAzureStorageConnectionString");
            var invDataBackupAzureStorageContainer = this._formBuilder.getValueByName("invDataBackupAzureStorageContainer");
            var customDataAzureStorageConnectionString = this._formBuilder.getValueByName("customDataAzureStorageConnectionString");
            var customDataAzureStorageContainer = this._formBuilder.getValueByName("customDataAzureStorageContainer");
            var port = this._formBuilder.getValueByName("port");
            var organization = this._formBuilder.getValueByName("organization");
            var environmentPool = this._formBuilder.getValueByName("environmentPool");

            var model = {
                id: this._dataEnvironmentId,
                subdomain: subdomain.trim(),
                description: description.trim(),
                siteVirtualPath: siteVirtualPath.trim(),
                isTestEnvironment: isTestEnvironment,
                invDataConnectionString: invDataConnectionString.trim(),
                invDataAdminConnectionString: invDataAdminConnectionString.trim(),
                invDataBackupAzureStorageConnectionString: invDataBackupAzureStorageConnectionString.trim(),
                invDataBackupAzureStorageContainer: invDataBackupAzureStorageContainer.trim(),
                customDataAzureStorageConnectionString: customDataAzureStorageConnectionString.trim(),
                customDataAzureStorageContainer: customDataAzureStorageContainer.trim(),
                port: port,
                organizationId: organization,
                environmentPoolId: environmentPool
            };

            return model;
        }

        public isDirty() {
            return this._isDirty;
        }

        public isValid() {
            return !this._formBuilder.hasErrors();
        }
    }

}
